import React, { useState } from "react";
import axios from "axios";

const Search = ({ onResults, onPrint }) => {
  const [query, setQuery] = useState("");

  const handleSearch = async () => {
    if (!query.trim()) return;

    try {
      // ✅ Backend should send ALL members, then filter in frontend
      const res = await axios.get("https://api.ssvdevelopers.co.in/members");
      const allMembers = res.data;

      // ✅ Partial match (case-insensitive) for ID, name, or mobileNo
      const results = allMembers.filter((m) =>
        (m.Id && m.Id.toLowerCase().includes(query.toLowerCase())) ||
        (m.name && m.name.toLowerCase().includes(query.toLowerCase())) ||
        (m.mobileNo && m.mobileNo.includes(query))
      );

      onResults(
        results.map(({ mobileNo, ...rest }) => rest) // removes mobileNo key
      );

    } catch (err) {
      console.error(err);
      onResults([]);
    }
  };

  return (
    <div style={{ marginBottom: "20px", display: "flex", alignItems: "center" }}>
      <input
        type="text"
        placeholder="Search by ID, Name, or Phone..."
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        style={{
          padding: "8px",
          width: "250px",
          marginRight: "10px",
          border: "1px solid #ccc",
          borderRadius: "6px",
        }}
      />
      <button
        onClick={handleSearch}
        style={{
          padding: "8px 16px",
          backgroundColor: "#0d6efd",
          color: "white",
          border: "none",
          borderRadius: "6px",
          cursor: "pointer",
          marginRight: onPrint ? "10px" : "300px",
        }}
      >
        Search
      </button>
      {onPrint && (
        <button
          onClick={onPrint}
          style={{
            padding: "8px 16px",
            backgroundColor: "#0d6efd",
            color: "white",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
            fontWeight: "bold",
            marginRight: "300px",
          }}
        >
          My Team
        </button>
      )}
    </div>
  );
};

export default Search;
